import React, { useEffect, useState } from 'react';
import * as api from '../../billMemory/api';
import { INTRO_TEXT } from '../../billMemory/client';

/**
 * Bill Memory's one-time introduction (Fix plan, Fix 12): one line at the top of Stock In, the first time
 * each user opens it after a source turns On, with a Close link. Closing is remembered on the server for
 * that user (GET /access → introDue). It never blocks the page; nothing on error.
 */
export default function IntroLine({ on }) {
  const [due, setDue] = useState(false);
  useEffect(() => {
    if (!on) { setDue(false); return undefined; }
    let cancelled = false;
    api.getAccess().then((r) => { if (!cancelled) setDue(!!(r && r.success && r.introDue)); }).catch(() => {});
    return () => { cancelled = true; };
  }, [on]);
  if (!due) return null;
  const close = () => { setDue(false); api.dismissIntro().catch(() => {}); };
  return (
    <div className="stockin-unit-cost-display" style={{ margin: '0 0 8px' }}>
      <span>{INTRO_TEXT} </span>
      <button type="button" className="bm-link" onClick={close}
        style={{ background: 'none', border: 'none', padding: 0, color: 'inherit', textDecoration: 'underline', cursor: 'pointer', font: 'inherit' }}>
        Close
      </button>
    </div>
  );
}
